/**
 * The header of a page that is not the workspace: a title, one primary action,
 * and — where the screen needs it — one line saying what the page holds.
 */
import type { ReactNode } from 'react';

export function PageHeader({
  title,
  lead,
  actions,
}: {
  title: string;
  lead?: string;
  actions?: ReactNode;
}) {
  return (
    <header className="ae-pagehead">
      <h1>{title}</h1>
      {actions}
      {lead ? <p className="ae-pagelead">{lead}</p> : null}
    </header>
  );
}
